import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../../hooks/useAuth'
import { APP_VERSION } from '../../version'
import styles from './Sidebar.module.css'

interface SidebarProps {
  open: boolean
  onClose: () => void
}

const NAV_ITEMS = [
  { path: '/dashboard', labelKey: 'nav.dashboard' },
  { path: '/payroll', labelKey: 'nav.payroll' },
  { path: '/employees', labelKey: 'nav.employees' },
  { path: '/declarations', labelKey: 'nav.declarations' },
  { path: '/accounting', labelKey: 'nav.accounting' },
  { path: '/absences', labelKey: 'nav.absences' },
  { path: '/documents', labelKey: 'nav.documents' },
  { path: '/settings', labelKey: 'nav.settings' },
] as const

export function Sidebar({ open, onClose }: SidebarProps) {
  const { t } = useTranslation()
  const { user, logout } = useAuth()

  return (
    <>
      {open && <div className={styles.overlay} onClick={onClose} />}
      <aside className={`${styles.sidebar} ${open ? styles.open : ''}`}>
        <div className={styles.logo}>
          <span className={styles.logoText}>MIREY</span>
          {user && (
            <span className={styles.companyName}>{user.company.name}</span>
          )}
        </div>

        <nav className={styles.nav}>
          {NAV_ITEMS.map(item => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `${styles.navItem} ${isActive ? styles.navItemActive : ''}`
              }
              onClick={onClose}
            >
              {t(item.labelKey)}
            </NavLink>
          ))}
        </nav>

        <div className={styles.footer}>
          {user && (
            <div className={styles.userInfo}>
              <span className={styles.userName}>
                {user.firstName} {user.lastName}
              </span>
              <button
                className={styles.logoutButton}
                onClick={logout}
              >
                {t('auth.logout')}
              </button>
            </div>
          )}
          <span className={styles.version} data-version>v{APP_VERSION}</span>
        </div>
      </aside>
    </>
  )
}
